module.exports = __webpack_public_path__ + "static/media/head-text-of-ratings-section.64b6bfbc.png";